'use strict';

const cookieHelper = require('friartux/components/cookieHelper');

const CONSENT_CATEGORY = 'marketing';
const CONSENT_EVENTS = ['CookiebotOnConsentReady', 'CookiebotOnDecline'];
const POPTIN_KEY_PATTERN = /poptin/i;

/**
 * Whether Cookiebot is present and currently holds marketing consent.
 * Returns null when Cookiebot is not on the page (CMP disabled), so callers can leave
 * Poptin alone instead of treating "no CMP" as a decline.
 * @returns {boolean|null} true/false under Cookiebot, null when Cookiebot is absent
 */
function hasMarketingConsent() {
    if (!window.Cookiebot || !window.Cookiebot.consent) {
        return null;
    }

    return window.Cookiebot.consent[CONSENT_CATEGORY] === true;
}

/**
 * Removes every Poptin-owned key from a Web Storage area.
 * @param {Storage} storage - window.localStorage or window.sessionStorage
 */
function clearStorage(storage) {
    try {
        Object.keys(storage)
            .filter((key) => POPTIN_KEY_PATTERN.test(key))
            .forEach((key) => storage.removeItem(key));
    } catch (e) {
        // Storage can throw when blocked by the browser - nothing to clean up in that case.
    }
}

/**
 * Removes the cookies, storage and injected DOM Poptin created while it was consented.
 *
 * Cookiebot keeps the loader inert on a fresh page load after a decline, but a visitor who
 * withdraws consent on a page where Poptin already ran leaves a live widget and its cookies
 * behind until the next request. This clears both so "Decline" takes effect immediately.
 */
function purge() {
    document.cookie.split(';').forEach((entry) => {
        const name = entry.split('=')[0].trim();

        if (name && POPTIN_KEY_PATTERN.test(name)) {
            cookieHelper.deleteCookie(name);
        }
    });

    clearStorage(window.localStorage);
    clearStorage(window.sessionStorage);

    document.querySelectorAll('[id*="poptin"], [class*="poptin"]').forEach((node) => {
        node.parentNode.removeChild(node);
    });
}

/**
 * Watches Cookiebot for the marketing category and purges Poptin whenever consent is absent.
 *
 * Poptin itself is blocked server-side (type="text/plain" data-cookieconsent="marketing" in
 * components/poptinScript.isml), so this only handles the withdrawal case Cookiebot cannot
 * undo on its own: Accept, then Decline, without a page reload.
 */
function init() {
    CONSENT_EVENTS.forEach((eventName) => {
        window.addEventListener(eventName, () => {
            if (hasMarketingConsent() === false) {
                purge();
            }
        });
    });
}

module.exports = {
    init: init
};
